(function () {
  var boundGuides = new WeakSet();
  var guideState = new WeakMap();
  function guideFor(trigger) {
    var scope = trigger.closest('[data-lh-size-guide-scope]');
    if (scope) return scope.querySelector('dialog.sizechart_main');
    var legacyScope = trigger.closest('[data-section-type="product"], [data-section-type="featured-product"]');
    if (legacyScope) return legacyScope.querySelector('dialog.sizechart_main');
    if (trigger.matches('.template-product a[href="/pages/size-guide"]')) {
      return document.querySelector('.shopify-section--main-product dialog.sizechart_main');
    }
    return null;
  }
  function bindGuide(dialog) {
    if (boundGuides.has(dialog)) return;
    boundGuides.add(dialog);
    dialog.addEventListener('close', function () {
      var state = guideState.get(dialog);
      if (!state) return;
      document.documentElement.style.overflow = state.overflow;
      if (state.trigger.isConnected) state.trigger.focus({ preventScroll: true });
      guideState.delete(dialog);
    });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  }
  function bindGuides() {
    document.querySelectorAll('.size_chart_open_btn').forEach(function (trigger) {
      var dialog = guideFor(trigger);
      if (!dialog) return;
      bindGuide(dialog);
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
    });
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.size_chart_open_btn, .template-product a[href="/pages/size-guide"]');
    if (trigger) {
      var dialog = guideFor(trigger);
      if (!dialog) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      bindGuide(dialog);
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
      if (!dialog.open) {
        guideState.set(dialog, { trigger: trigger, overflow: document.documentElement.style.overflow });
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
      return;
    }
    var close = event.target.closest('.size_close_button');
    if (close) {
      var guide = close.closest('dialog.sizechart_main');
      if (!guide) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      guide.close();
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindGuides);
  else bindGuides();
  document.addEventListener('shopify:section:load', bindGuides);
  document.addEventListener('dialog:after-show', bindGuides);
})();

(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.LhReviewJump');
    if (!link || !['#lh-ratings-reviews', '#lh-customer-reviews'].includes(link.getAttribute('href'))) return;
    var targetId = link.getAttribute('href').slice(1);
    var reviews = document.getElementById(targetId);
    if (!reviews) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var header = document.getElementById('shopify-section-header');
    var offset = header ? header.getBoundingClientRect().height + 24 : 160;
    var top = reviews.getBoundingClientRect().top + window.scrollY - offset;
    reviews.setAttribute('tabindex', '-1');
    reviews.focus({ preventScroll: true });
    window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
    if (location.hash !== '#' + targetId) history.pushState(null, '', '#' + targetId);
  }, true);
})();


(function () {
  function initFamilyReviews() {
    var root = document.getElementById('lh-ratings-reviews');
    if (!root) return;
    var list = root.querySelector('.lh-reviews__junip');
    var toggle = root.querySelector('.LhReviewsToggle');
    if (!list || !toggle || toggle.dataset.ready) return;
    toggle.dataset.ready = 'true';
    var expanded = false;
    function update() {
      var cards = Array.from(list.querySelectorAll('.junip-review-grid-item-container'));
      cards.forEach(function (card, index) {
        card.toggleAttribute('data-lh-review-overflow', !expanded && index >= 4);
      });
      list.querySelectorAll('.lh-reviews__junip-product').forEach(function (group) {
        var groupCards = Array.from(group.querySelectorAll('.junip-review-grid-item-container'));
        group.toggleAttribute('data-lh-review-group-hidden', !expanded && groupCards.length > 0 && groupCards.every(function (card) { return card.hasAttribute('data-lh-review-overflow'); }));
      });
      list.toggleAttribute('data-lh-collapsed', !expanded);
      toggle.hidden = cards.length <= 4;
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel;
    }
    toggle.addEventListener('click', function () {
      expanded = !expanded;
      update();
      if (!expanded) root.querySelector('.LhFamilyRating').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    new MutationObserver(update).observe(list, { childList: true, subtree: true });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFamilyReviews);
  else initFamilyReviews();
  document.addEventListener('shopify:section:load', initFamilyReviews);
})();


document.addEventListener('click',function(event){
 const toggle=event.target.closest('.ctm-collapsible-tab .Collapsible__Button');
 if(toggle){event.preventDefault();toggle.setAttribute('aria-expanded',toggle.getAttribute('aria-expanded')!=='true'?'true':'false');}
 const sticky=event.target.closest('[data-lh-option]');
 if(sticky){const form=sticky.closest('[data-lh-form]').dataset.lhForm;const pickers=document.querySelectorAll('variant-picker');for(const picker of pickers){if(picker.getAttribute('form-id')===form){const radio=Array.from(picker.querySelectorAll('input[type="radio"]')).find(r=>r.value===sticky.dataset.lhOption);if(radio)radio.click();break;}}}
});
(() => {
 const cache = new Map();
 let sequence = 0;
 document.addEventListener('click', async event => {
  const link = event.target.closest('.shopify-section--featured-collections .lh-card-swatches a.ColorSwatch');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const card = link.closest('product-card');
  if (!card) return;
  event.preventDefault();
  const token = String(++sequence);
  card.dataset.lhPending = token;
  card.setAttribute('aria-busy', 'true');
  try {
   const url = new URL(link.href, location.origin);
   if (url.origin !== location.origin) throw new Error('Unexpected product origin');
   url.searchParams.set('section_id', 'lh-card-swap');
   let html = cache.get(url.href);
   if (!html) {
    const response = await fetch(url.href, {credentials: 'same-origin'});
    if (!response.ok) throw new Error('Product card unavailable');
    html = await response.text();
    cache.set(url.href, html);
   }
   if (card.dataset.lhPending !== token || !card.isConnected) return;
   const source = new DOMParser().parseFromString(html, 'text/html').querySelector('product-card');
   if (!source) throw new Error('Product card missing');
   const ids = new Map();
   source.querySelectorAll('[id]').forEach(el => { const old = el.id; el.id += '-lh-' + token; ids.set(old, el.id); });
   source.querySelectorAll('*').forEach(el => {
    for (const attr of ['for','form','aria-controls','aria-labelledby','aria-describedby']) {
     if (el.hasAttribute(attr)) el.setAttribute(attr, el.getAttribute(attr).split(' ').map(v => ids.get(v) || v).join(' '));
    }
    if (el.matches('input[type="radio"]') && el.name) el.name += '-lh-' + token;
   });
   const replacement = document.importNode(source, true);
   card.replaceWith(replacement);
   const focusTarget = replacement.querySelector('.product-card__title a, .product-card__title, a[href]');
   if (focusTarget) focusTarget.focus({preventScroll:true});
  } catch (_) {
   if (card.dataset.lhPending === token) location.assign(link.href);
  } finally {
   if (card.isConnected && card.dataset.lhPending === token) card.removeAttribute('aria-busy');
  }
 });
})();
